import type { UIViewInjectedProps } from '@uirouter/react';

import { Attachments } from '@/components/attachments';
import { AttachmentType } from '@/types/enums';

export const CooperativeLegalAttachments = ({ transition }: UIViewInjectedProps) => {
  const params = {
    transition,
    apiEntity: 'CooperativeLegal',
    paramId: 'cooperativeId',
    attachmentType: AttachmentType.CooperativeLegal,
    closeRoute: 'base-layout.cooperatives.view',
    isDrawerLayout: false,
  };

  return <Attachments<cyrian.api.cooperatives.CooperativeWithAttachment> {...params} />;
};
